import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import Sparkline from '../../../components/Sparklines';

export const module1Keys = [
    {
        key: 'clicksL',
        label: 'Clicks',
        icon: 'pagev-view',
    },
    {
        key: 'impressionsL',
        label: 'Impressions',
        icon: 'pagev-view',
    },
    {
        key: 'ctrL',
        label: 'Avg Ctr',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'search',
    },
    {
        key: 'positionL',
        label: 'Postion',
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
];

export const tableColumns = [
    {
        label: 'Search Appearance',
        key: 'searchappearance',
        data: 'searchappearance',
        Component: Cell,
    },
    {
        label: 'Impressions',
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: 'Clicks',
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: 'Trend',
        key: 'sparkline',
        data: 'sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';

            return (
                <Sparkline
                    labels={item.dateL.map((x) => x.value)}
                    dataL={item.clicksL}
                    keyName="Clicks"
                />
            );
        },
    },
    {
        label: 'Position',
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: 'Avg CTR',
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item }) => numeral(item.clicks / item.impressions).format('0.00%'),
    },
];

export function getPercentForChart(allData, oneData) {
    const sumAllData = allData.reduce((acc, curr) => acc + curr, 0);
    const percent = (100 * oneData) / sumAllData;
    return percent;
}
